import React from "react";
import styles from "./style.module.css";
const index = ({
  subtitle,
  title,
  imageUrl,
  href,
}: {
  subtitle: string;
  title: string;
  imageUrl: string;
  href: string;
}) => {
  return (
    <a
      rel={
        href?.includes("list") ||
        href?.includes("map") ||
        href?.includes("?") ||
        href?.includes("conditions") ||
        href?.includes("contact")
          ? "noindex, nofollow, noreferrer"
          : "dofollow"
      }
      className={styles.articleCardNew}
      href={href}
    >
      <img className={styles.photoSectionIcon} alt="" src={imageUrl} />
      <div className={styles.contentSection}>
        <div className={styles.commentAMarcheWrapper}>
          <div className={styles.commentAMarche1}>{subtitle}</div>
        </div>
        <div className={styles.crditImmobilierAuMarocLWrapper}>
          <div className={styles.crditImmobilierAu1}>{title}</div>
        </div>
      </div>
    </a>
  );
};

export default index;
